import styled from "styled-components";

export const NotesContainer = styled.div`
    display: flex;
`;